// @core/api/endpoints/userprofile/update_banner.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BannerResponse,
  UpdateBannerRequest,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Update banner
 * Updates banner metadata such as cropping parameters or display settings. Does not replace the image itself.
 */
export async function UpdateBanner(
  profile_id: string,
  banner_id: string,
  data: UpdateBannerRequest,
  options?: RequestOptions
): Promise<BannerResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/banners/:banner_id`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  requestPath = requestPath.replace(':banner_id', encodeURIComponent(banner_id));
  const requestOptions = options;
  return client.put<BannerResponse>(requestPath, data, requestOptions);
}
